<div class="sidebar__brand">
  <img
    class="sidebar__brand-wordmark"
    ngSrc="/logo.png"
    alt="Savant Payment Gateway"
    width="176"
    height="32"
    priority
  />
  <button
    class="btn btn--ghost btn--icon btn--sm sidebar__brand-toggle"
    type="button"
    [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
    [attr.aria-pressed]="collapsed()"
    (click)="toggleCollapse.emit()"
  >
    <i
      class="ph"
      [class.ph-caret-double-left]="!collapsed()"
      [class.ph-caret-double-right]="collapsed()"
    ></i>
  </button>
</div>

<div class="sidebar__search">
  <div class="input-group">
    <span class="input-group__icon" aria-hidden="true"><i class="ph ph-magnifying-glass"></i></span>
    <input
      #filterInput
      class="input"
      id="sidebar-filter"
      type="search"
      placeholder="Filter menu"
      aria-label="Filter menu"
      [value]="filter()"
      (input)="onFilterInput(filterInput.value)"
    />
  </div>
</div>

<div class="sidebar__scroll scroll-thin">
  <nav class="nav" aria-label="Main">
    @for (section of visibleSections(); track section.title) {
      <div class="nav__section">
        <p class="nav__section-title">{{ section.title }}</p>
        @for (item of section.items; track item.path) {
          <a
            class="nav__item"
            [routerLink]="item.path"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: true }"
            #link="routerLinkActive"
            [attr.aria-current]="link.isActive ? 'page' : null"
            [attr.title]="collapsed() ? item.label : null"
            (click)="navigated.emit()"
          >
            <i class="ph ph-{{ item.icon }}" aria-hidden="true"></i><span>{{ item.label }}</span>
          </a>
        }
      </div>
    } @empty {
      <p class="sidebar__no-results">No menu item matches “{{ filter() }}”.</p>
    }
  </nav>
</div>

<div class="sidebar__footer">
  <nav class="nav" aria-label="Administration">
    @for (item of visibleSupportItems(); track item.path) {
      <a
        class="nav__item"
        [routerLink]="item.path"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
        #link="routerLinkActive"
        [attr.aria-current]="link.isActive ? 'page' : null"
        [attr.title]="collapsed() ? item.label : null"
        (click)="navigated.emit()"
      >
        <i class="ph ph-{{ item.icon }}" aria-hidden="true"></i><span>{{ item.label }}</span>
      </a>
    }
  </nav>

  <a class="user-card" routerLink="/a/profile" (click)="navigated.emit()">
    <span class="avatar" aria-hidden="true">{{ userInitials() }}</span>
    <span class="user-card__text">
      <span class="user-card__name truncate">{{ userName() }}</span>
      <span class="user-card__role truncate">{{ userRole() }}</span>
    </span>
  </a>
</div>
